import { Flex, Text } from '@chakra-ui/layout'
import { Switch } from '../../components/Switch'
import { Input } from '@chakra-ui/input'
import { InputInnovationDoubleDate } from './components/InputInnovationDoubleDate'
import { InputInnovationText } from './components/InputInnovationText'
import { Button } from './components/Button'
import { InputInnovationSelect } from './components/InputInnovationSelect'
import { useEffect, useState } from 'react'
import { FaCheckCircle } from 'react-icons/fa'
import { Date as DateComponent } from '../../components/Date'
import { Icon } from '@chakra-ui/icon'
import { ModalCliente } from './components/ModalCliente'
import { DropdownCheckbox } from './components/DropdownCheckbox'
import { format } from 'date-fns'
import { formatPrice } from '../../utils/formatPrice'
import { useMutation } from 'react-query'
import { useParams, useSearchParams } from 'react-router-dom'
import { api } from '../../services/api'
import { useForm } from 'react-hook-form'
import { IoMdClose } from 'react-icons/io'
import { errorHandler } from '../../services/errorHandlerPropostas'
import { infoColor } from '../../utils/infoColorFunil'

async function getPropostasAcompanhamento({ params, userCode, setMeta }) {
  const response = await api.get(`/chamado/listar-pedidos-vendedores`, {
    params: {
      codigo_consultor: userCode,
      ...params,
    },
  })

  const meta = {
    totalPages: response.data.total_pages,
    totalItens: response.data.total_itens,
    perPage: response.data?.data?.to,
    limit: response.data?.data?.limit,
  }

  setMeta(meta)

  const infoEnterprise = {
    'INNOVATION COMERCIO DE BRINDES': 'INN',
    'D & T COMERCIO DE BRINDES EIRELI': 'DT',
  }

  return response.data.data.data.map((item) => {
    return {
      ...item,
      link_proposta: `${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-pdf-sankhya/${item.nunota}`,
      data_saida: item.data_saida ? format(new Date(item.data_saida), 'dd/MM/yyyy') : '',
      passo_atual: item.passo_atual ? item.passo_atual.toLowerCase() : '',
      valor_total_parceiro: item.valor_total_parceiro ? formatPrice(item.valor_total_parceiro) : '',
      data_passo_atual: item.data_passo_atual,
      abertura: item.data_abertura ? format(new Date(item.data_abertura), 'dd/MM/yyyy HH:mm') : '',
      lineColor: infoColor[item.funil_vendas?.toUpperCase()],
      data_funil: item.data_status ? format(new Date(item.data_status), 'dd/MM/yyyy HH:mm') : '',
      abertura_order: item.data_abertura,
      retornar_em_order: item.retorno_cliente,
      proposta: item.codigo_proposta,
      desconto: item.desconto ? item.desconto : '',
      desconto_order: item.desconto === 'S' ? 1 : 0,
      cliente: item.nome_cliente?.toLowerCase() || '',
      verba: item.verba ? item.verba : '',
      empresa_tag: infoEnterprise[item.empresa.toUpperCase()] || '',
      propostaEncaminhada: item.data_proposta_encaminhada,
      layoutEnviado: item.data_encaminhamento_layout ? format(new Date(item.data_encaminhamento_layout), 'dd/MM/yyyy HH:mm') : '',
      funilVendas: item.funil_vendas?.toLowerCase() || '',
      ultimoContato: item.data_perda ? format(new Date(item.data_perda), 'dd/MM/yyyy HH:mm') : '',
      valorProposta: item.valor_proposta ? formatPrice(item.valor_proposta) : '',
      retornarEm: item.retorno_cliente ? format(new Date(item.retorno_cliente), 'dd/MM/yyyy HH:mm') : '',
      dataPropostaEncaminhada: item.data_proposta_encaminhada ? format(new Date(item.data_proposta_encaminhada), 'dd/MM/yyyy HH:mm') : '',
      info_proposta:
        item?.info_proposta &&
        item?.info_proposta?.map((item) => {
          return {
            ...item,
            codigo_produto: item.codigo_produto,
            cor: item.cor,
            quantidade_itens: new Intl.NumberFormat('pt-BR').format(item.quantidade_itens),
          }
        }),
      data_controle: item.dt_mov ? format(new Date(item.dt_mov), 'dd/MM/yyyy HH:mm') : '',
      info_layout:
        item.info_layout &&
        item.info_layout.map((item) => {
          return {
            ...item,
            link_layout: item.link_layout,
            codigo_produto: item.codigo_produto,
            cor: item.cor,
            solicitacao: item.solicitacao
              ? //dd/MM/yyyy às HH:mm
                format(new Date(item.solicitacao), "dd/MM/yyyy '/' HH:mm")
              : '',
            encaminhado: item.encaminhado ? format(new Date(item.encaminhado), "dd/MM/yyyy '/' HH:mm") : '',
            nome_usuario: item.nome_usuario ? item.nome_usuario : '',
          }
        }),
    }
  })
}

export function Filtro({ setData, setLoading, setMeta }) {
  const [openModalCliente, setOpenModalCliente] = useState(false)
  const [valueModalCliente, setValueModalCliente] = useState({
    value: '',
    label: '',
  })
  const {
    handleSubmit,
    register,
    watch,
    setValue,
    setError,
    control,
    formState: { errors },
  } = useForm()
  const { idVendedor } = useParams()

  const [searchParams, setSearchParams] = useSearchParams()

  async function onSubmit(data) {
    const isValid = errorHandler(data, setError)

    if (!isValid) return

    setLoading(true)

    const parameters = {
      cliente: data.tipo_cliente,
      data_inicio: data.de,
      data_fim: data.ate,
      numero_proposta: data.numero_proposta,
      clientes: clientesSelected.map((item) => item.codigo_cliente).join(','),
      prazos: prazos.map((item) => item.value).join(','),
      proposta_especial: data.proposta_especial,
      cliente_especial: data.cliente_especial,
      retornar_em: data.retornar_em,
    }

    await mutateAsync({ params: parameters, userCode: idVendedor })
  }

  const {
    data: dataCustomer,
    isLoading,
    mutateAsync,
  } = useMutation({
    mutationFn: ({ params, userCode: idVendedor }) =>
      getPropostasAcompanhamento({
        params: params,
        userCode: idVendedor,
        setMeta,
      }),
    onSuccess: (data) => {
      setData(data)
      setLoading(false)
    },
  })

  const [prazos, setPrazos] = useState(
    searchParams
      .get('prazos')
      ?.split(',')
      .map((item) => {
        return {
          value: parseInt(item),
          label: `${item} dias`,
        }
      }) || []
  )
  const [clientesSelected, setClientesSelected] = useState([])

  function handlePrazos(value) {
    const prazo = prazos.find((item) => item.value === value.value)

    if (prazo) {
      setPrazos(prazos.filter((item) => item.value !== value.value))
    } else {
      setPrazos([...prazos, value])
    }
  }

  function handleClientesSelected(value) {
    setClientesSelected(value)
    handleSearchParams({
      clientes: value.map((item) => item.codigo_cliente).join(','),
    })
    setOpenModalCliente(false)
  }

  useEffect(() => {
    setLoading(true)
    const params = Object.fromEntries(searchParams)
    console.log('params', params)
    //chama o mutate async com os parametros da url
    mutateAsync({ params: params, userCode: idVendedor })
  }, [searchParams, idVendedor])

  function handleSearchParams(params) {
    //guarda os parametros que ja estavam na url e adiciona os novos
    const newParams = new URLSearchParams(searchParams)

    setSearchParams({
      ...Object.fromEntries(newParams),
      ...params,
    })
  }

  async function clearAllFilters() {
    setValue('numero_proposta', '')
    setValue('de', '')
    setValue('ate', '')
    setValue('retornar_em', '')
    setValue('proposta_especial', false)
    setValue('cliente_especial', false)

    setPrazos([])
    setClientesSelected([])

    await mutateAsync({ params: {}, userCode: idVendedor })
  }

  const proposta_especial = watch('proposta_especial')
  const cliente_especial = watch('cliente_especial')
  const retornar_em = watch('retornar_em')

  useEffect(() => {
    setValue('proposta_especial', searchParams.get('proposta_especial') === 'true')
    setValue('desconto', searchParams.get('desconto') === 'true')
    setValue('cliente_especial', searchParams.get('cliente_especial') === 'true')
    setValue('retornar_em', searchParams.get('retornar_em'))
  }, [searchParams])

  useEffect(() => {
    const handleEnter = (e) => {
      if (e.key === 'Enter') {
        e.preventDefault()
        handleSubmit(onSubmit)()
      }
    }

    document.addEventListener('keydown', handleEnter)

    return () => {
      document.removeEventListener('keydown', handleEnter)
    }
  }, [])

  return (
    <>
      <ModalCliente
        isOpen={openModalCliente}
        onClose={() => setOpenModalCliente(false)}
        value={valueModalCliente}
        handleClientesSelected={handleClientesSelected}
      />
      <Flex alignItems="center" justifyContent="space-between" w="100%" maxW="1339px" mx="auto" as="form">
        <InputInnovationSelect
          maxW="425px"
          flex={1}
          options={[
            { label: 'Nome do Cliente', value: 'NomeCliente' },
            { label: 'CPF/CNPJ', value: 'CpfCnpj' },
            { label: 'Código do Cliente', value: 'CodigoCliente' },
            { label: 'E-mail', value: 'Email' },
          ]}
          control={control}
          name="tipo_cliente"
          error={errors.tipo_cliente}
        />

        <InputInnovationText maxW="202px" w="100%" label="Nº Proposta" name="numeroProposta" {...register('numero_proposta')} />
        <InputInnovationDoubleDate maxW="308px" w="100%">
          <Text color="#378BBF" fontSize="13px" fontWeight="semibold">
            De:
          </Text>
          <Input
            type="date"
            border="0"
            padding="0"
            outline="0"
            boxShadow="0"
            fontSize="13px"
            h="100%"
            _focus={{
              boxShadow: '0',
            }}
            //manda o e.target.value para o onSubmit
            {...register('de')}
          />
          <Text color="#378BBF" fontSize="13px" fontWeight="semibold">
            Até:
          </Text>
          <Input
            type="date"
            border="0"
            padding="0"
            outline="0"
            fontSize="13px"
            boxShadow="0"
            h="100%"
            _focus={{
              boxShadow: '0',
            }}
            {...register('ate')}
          />
        </InputInnovationDoubleDate>

        <DateComponent label="Retornar em" h="29px" {...register('retornar_em')} />
      </Flex>
      <Flex alignItems="center" justifyContent="space-between" w="full" gap={2} mt={4} maxW="1339px" mx="auto">
        <Switch
          icon={<Icon as={FaCheckCircle} color="#378BBF" fontSize="25px" />}
          label="Proposta Importante"
          {...register('proposta_especial')}
          isChecked={proposta_especial}
          isDisabled={isLoading}
        />
        <Switch
          icon={<Icon as={FaCheckCircle} color="#FFA200" fontSize="25px" />}
          label="Cliente especial"
          {...register('cliente_especial')}
          isDisabled={isLoading}
          isChecked={cliente_especial}
        />

        <DropdownCheckbox
          maxW="100px"
          h="29px"
          label="Prazos:"
          setValue={handlePrazos}
          quantitySelected={prazos?.length}
          options={[
            { label: '1 dia', value: 1 },
            { label: '2 dias', value: 2 },
            { label: '3 dias', value: 3 },
            { label: '4 dias', value: 4 },
            { label: '5 dias', value: 5 },
            { label: '6 dias', value: 6 },
            { label: '7 dias', value: 7 },
            { label: '8 dias', value: 8 },
            { label: '9 dias', value: 9 },
            { label: '10 dias', value: 10 },
          ]}
          defaultValue={searchParams
            .get('prazos')
            ?.split(',')
            ?.map((item) => parseInt(item))}
        />

        <Flex alignItems="center" justifyContent="flex-end" gap={2} ml="auto" maxW="340px" w="100%">
          <Button
            maxW="181px"
            onClick={handleSubmit(onSubmit)}
            w="100%"
            ml="10px"
            disabled={isLoading}
            isLoading={isLoading}
            loadingText="Atualizando..."
          >
            Atualizar
          </Button>
          <Button
            bgColor="transparent"
            color="#378bbf"
            border="1px solid #378BBF"
            maxW="131px"
            w="100%"
            ml="5px"
            disabled={isLoading}
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={2}
            onClick={clearAllFilters}
            type="reset"
          >
            <IoMdClose /> Limpar
          </Button>
        </Flex>
      </Flex>
    </>
  )
}
